import { processSingle } from './processSingle';
import { processMultiple } from './processMultiple';
export var processKeyboardEvent = function processKeyboardEvent(e, options) {
  if (options.multiple) {
    return processMultiple(e, options);
  }

  return processSingle(e, options);
};